export function getTypeBadge(type)
{
	const map =
		{
			ROOT: {color: "#E31E24", label: "root", style: {color: "#fff"}},
			CONSORZIO: {color: "volcano", label: "consorzio", style: {color: "#f00"}},
			COOPERATIVA: {color: "geekblue", label: "cooperativa", style: {color: "#00f"}},
			CANALE: {color: "purple", label: "canale", style: {color: "purple"}}
		};

	return map[type] || {color: "default", label: (type || "").toLowerCase()};
}
